import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgOkAlt(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.24942 2.24942C0 4.49884 0 8.11923 0 15.36V16.64C0 23.8808 0 27.5012 2.24942 29.7506C4.49884 32 8.11923 32 15.36 32H16.64C23.8808 32 27.5012 32 29.7506 29.7506C32 27.5012 32 23.8808 32 16.64V15.36C32 8.11923 32 4.49884 29.7506 2.24942C27.5012 0 23.8808 0 16.64 0H15.36C8.11923 0 4.49884 0 2.24942 2.24942ZM16.0313 15.5564C17.5047 15.5564 18.8356 14.9543 19.8021 13.9879C20.7686 13.0214 21.3706 11.6905 21.3706 10.217C21.3706 8.74349 20.7686 7.41262 19.8021 6.44612C18.8356 5.47967 17.5047 4.8776 16.0313 4.8776C14.5577 4.8776 13.2269 5.47967 12.2604 6.44612C11.2939 7.41262 10.6919 8.74349 10.6919 10.217C10.6919 11.6905 11.2939 13.0214 12.2604 13.9879C13.2269 14.9543 14.5577 15.5564 16.0313 15.5564ZM14.3201 8.48998C14.7637 8.04636 15.3658 7.77704 16.0313 7.77704C16.6967 7.77704 17.2988 8.06222 17.7424 8.48998C18.186 8.93365 18.4553 9.53572 18.4553 10.2011C18.4553 10.8666 18.186 11.4687 17.7424 11.9123C17.2988 12.3559 16.6967 12.6253 16.0313 12.6253C15.3658 12.6253 14.7637 12.3559 14.3201 11.9123C13.8765 11.4687 13.6071 10.8666 13.6071 10.2011C13.6071 9.53572 13.8765 8.93365 14.3201 8.48998ZM23.2085 17.7112L21.64 15.5722C21.5608 15.4455 21.3865 15.4297 21.2597 15.5247C19.7704 16.7922 17.9642 17.6002 16.0154 17.6002C14.0666 17.6002 12.2446 16.7764 10.7711 15.5247C10.6601 15.4297 10.5017 15.4455 10.4066 15.5722L8.83812 17.7112C8.75888 17.8062 8.79059 17.9647 8.88565 18.0439C10.2165 19.1213 11.7376 19.8343 13.3378 20.2145L10.3116 26.0292C10.2324 26.1877 10.3433 26.3937 10.5334 26.3937H13.7656C13.8765 26.3937 13.9715 26.3303 14.0032 26.2352L16.0313 21.4345L18.0434 26.2511C18.091 26.3461 18.186 26.4095 18.2811 26.4095H21.5132C21.7034 26.4095 21.8143 26.2193 21.7351 26.0451L18.7089 20.2145C20.3091 19.8343 21.846 19.1213 23.161 18.0439C23.2719 17.9647 23.2878 17.8221 23.2085 17.7112Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgOkAlt);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
